<main class="flex flex-col items-center justify-center h-screen bg-gray-100 p-4">

  <div>
    <button (click)="generateToken()" class="p-2 border bg-red rounded m-4">Generate Token</button>
  </div>
  
  <form [formGroup]="recaptchaForm" (ngSubmit)="onSubmit()" class="w-full max-w-[976px]">
    <div>
      <label for="token">Token:</label>
      <input class="border p-2 w-full" id="token" formControlName="token" type="text" />
    </div>
    
    <div>
      <label for="websiteKey">Website Key:</label>
      <input class="border p-2 w-full" id="websiteKey" formControlName="websiteKey" type="text" />
    </div>
    
    <div>
      <label for="privateKey">Private Key:</label>
      <input class="border p-2 w-full" id="privateKey" formControlName="privateKey" type="text" />
    </div>
    
  <button type="submit"  class="p-2 border bg-green rounded m-4">Submit</button>
</form>

<div>
  {{ jsonData | json }}
</div>
</main>